import { Space, Spin } from "antd";
import React from "react";
import { LoadingOutlined } from "@ant-design/icons";

export const Loader = ({ size }) => {
  return (
    <div>
      <Space>
        <Spin indicator={<LoadingOutlined spin />} size={size} />
      </Space>
    </div>
  );
};
